import ApplicationController from '../application_controller'


class HistoryViewSettingsController extends ApplicationController {
  viewChanged (event) {
    const view = event.target.value

    const tabContainer = document.querySelector('.user_settings_history_tab .radio-buttons-inline')
    if (!tabContainer) return

    const allValues = ['process', 'contact', 'history']
    allValues.forEach(val => {
      const el = tabContainer.querySelector(`input[value="${val}"]`)?.closest('span.radio')
      if (el) el.remove()
    })

    const hiddenInput = document.querySelector('input[type="hidden"][name="user[settings][history_tab]"]')
    if (view === 'single') {
      hiddenInput.insertAdjacentElement('afterend', this.buildRadio('history', true))
    } else if (view === 'separate') {
      hiddenInput.insertAdjacentElement('afterend', this.buildRadio('contact', false))
      hiddenInput.insertAdjacentElement('afterend', this.buildRadio('process', true))
    }
  }

  buildRadio (value, checked) {
    const id = `user_settings_history_tab_${value}`
    const name = 'user[settings][history_tab]'

    const span = document.createElement('span')
    span.classList.add('radio')

    span.innerHTML = `
      <label for="${id}">
        <input class="radio_buttons optional"
               type="radio"
               value="${value}"
               name="${name}"
               id="${id}"
               ${checked ? 'checked' : ''}>
        ${I18n.t(`users.settings.history_tab_options.${value}`)}<span class="box"></span>
      </label>
    `
    return span
  }
}

export default HistoryViewSettingsController
